export default "__VITE_ASSET__DBko$5Ns__"